(function () {
  function updatePricesForRoot(root, api) {
    if (!root || !api) return;

    // Supports both product cards and product details in quick-add:
    // any element that carries the Regios DOPP data attributes.
    const dopElements = root.querySelectorAll(
      '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
    );

    dopElements.forEach(async (dopEl) => {
      const productId = Number(dopEl.dataset.regiosDoppProductId);
      const variantId = Number(dopEl.dataset.regiosDoppVariantId);
      const regularPriceInCents = Number(dopEl.dataset.regiosDoppRegularPriceCents);

      if (!productId || !variantId || !regularPriceInCents) return;

      const compareAtPriceInCents = dopEl.dataset.regiosDoppCompareAtPriceCents
        ? Number(dopEl.dataset.regiosDoppCompareAtPriceCents)
        : undefined;

      const parentItem = dopEl.closest('.resource-list__item');
      const collectionIdsAttr =
        dopEl.getAttribute('data-regios-dopp-collection-ids') ||
        (parentItem && parentItem.getAttribute('data-regios-dopp-collection-ids'));

      const collectionIds = collectionIdsAttr
        ? collectionIdsAttr
            .split(',')
            .map(function (id) {
              return Number(id.trim());
            })
            .filter(function (id) {
              return !Number.isNaN(id);
            })
        : undefined;

      try {
        const result = await api.calculateDiscountedPrices({
          productId: productId,
          variantId: variantId,
          regularPriceInCents: regularPriceInCents,
          ...(compareAtPriceInCents ? { compareAtPriceInCents } : {}),
          collectionIds: collectionIds,
        });

        // Discard stale result if the variant changed while awaiting the API response.
        if (Number(dopEl.dataset.regiosDoppVariantId) !== variantId) return;

        const { salePrice, regularPrice, description } = result;
        if (!salePrice || !regularPrice) return;

        const priceContainers = dopEl.querySelectorAll('.regios-dopp-generic-price-container');
        if (!priceContainers.length) return;

        const isOnSale = salePrice.amount < regularPrice.amount;

        // No DOPP discount applies — the existing Shopify price (and any
        // compare-at display) is already correct. Clean up any DOPP-created
        // elements from a previous run and leave the native display intact.
        if (!isOnSale) {
          priceContainers.forEach(function (/** @type {HTMLElement} */ priceContainer) {
            priceContainer.classList.remove('regios-dopp-generic-price--on-sale');
            var staleDesc = /** @type {HTMLElement|null} */ (
              priceContainer.querySelector('[data-created-by-regios-dopp]')
            );
            if (staleDesc) {
              staleDesc.style.display = 'none';
              staleDesc.innerHTML = '';
            }
          });
          var staleBadge = /** @type {HTMLElement|null} */ (dopEl.querySelector('[data-created-by-regios-dopp-badge]'));
          if (staleBadge) staleBadge.remove();
          return;
        }

        priceContainers.forEach(function (/** @type {HTMLElement} */ priceContainer) {
          const regularEl = priceContainer.querySelector('.regios-dopp-generic-price-item--regular');
          const saleEl = priceContainer.querySelector('.regios-dopp-generic-price-item--sale');

          if (regularEl) {
            if (isOnSale) {
              regularEl.style.display = 'initial';
              regularEl.style.textDecoration = 'line-through';
              regularEl.setAttribute('data-made-visible-by-regios-dopp', 'true');
            } else {
              regularEl.style.display = 'none';
              regularEl.style.textDecoration = '';
              regularEl.removeAttribute('data-made-visible-by-regios-dopp');
            }
            regularEl.textContent = regularPrice.formatted;
          }

          if (saleEl) {
            saleEl.textContent = salePrice.formatted;
          }

          if (isOnSale) {
            priceContainer.classList.add('regios-dopp-generic-price--on-sale');
          } else {
            priceContainer.classList.remove('regios-dopp-generic-price--on-sale');
          }

          var descriptionEl = priceContainer.querySelector('.regios-dopp-description');
          if (!descriptionEl) {
            descriptionEl = document.createElement('div');
            descriptionEl.className = 'regios-dopp-description';
            descriptionEl.setAttribute('data-created-by-regios-dopp', 'true');
            priceContainer.appendChild(descriptionEl);
          }

          if (description && description.html) {
            descriptionEl.innerHTML = description.html;
            descriptionEl.style.display = 'block';
            if (description.css) {
              descriptionEl.style.cssText += ';' + description.css;
            }
          } else {
            descriptionEl.style.display = 'none';
            descriptionEl.innerHTML = '';
          }
        });

        var badgesContainer = /** @type {HTMLElement|null} */ (dopEl.querySelector('.product-badges'));
        if (badgesContainer && badgesContainer.parentNode) {
          var discountPct = Math.round((1 - salePrice.amount / regularPrice.amount) * 100);
          var doppBadge = /** @type {HTMLElement|null} */ (dopEl.querySelector('[data-created-by-regios-dopp-badge]'));
          if (!doppBadge) {
            doppBadge = document.createElement('div');
            var saleColorScheme = dopEl.getAttribute('data-regios-dopp-sale-color-scheme');
            doppBadge.className =
              'product-badges__badge product-badges__badge--rectangle product-badges__badge--dopp' +
              (saleColorScheme ? ' color-' + saleColorScheme : '');
            doppBadge.setAttribute('data-created-by-regios-dopp-badge', 'true');
            doppBadge.setAttribute('data-created-by-regios-dopp', 'true');
            badgesContainer.parentNode.insertBefore(doppBadge, badgesContainer);
          }
          doppBadge.innerHTML = '<span>SALE</span><span>' + discountPct + '%</span>';
        }
      } catch (e) {
        console.error('Regios DOPP error (theme interop):', e);
      }
    });
  }

  function ensureApiThenUpdate(root) {
    if (!root) return;

    var run = function (api) {
      if (!api || !api.calculateDiscountedPrices) return;
      updatePricesForRoot(root, api);
    };

    if (window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0) {
      run(window.RegiosDOPP.api.v0);
    } else {
      window.addEventListener(
        'regios-dopp:api-initialized',
        function (e) {
          if (!e.detail || !e.detail.api) return;
          run(e.detail.api);
        },
        { once: true },
      );
    }
  }

  window.RegiosDoppThemeInterop = {
    ensureApiThenUpdate: ensureApiThenUpdate,
  };

  // Automatically apply to the whole document so any section
  // that renders product cards/prices benefits (collections,
  // product lists, recommendations, quick-add, etc.).
  var initGlobalRegiosDopp = function () {
    ensureApiThenUpdate(document);

    // After a swatch/variant change in the PLP, product-price.js replaces the
    // price container with fresh server HTML (losing DOPP output). We need to:
    // 1. Sync the new variant's data attrs from the section-rendered HTML onto
    //    the live card element (so DOPP calculates for the right variant).
    // 2. Re-run DOPP scoped to that card after the DOM update settles.
    // Capture phase (true) is required because product-card.js calls
    // event.stopPropagation() at the <product-card> level, which prevents
    // bubble-phase listeners on document from ever receiving this event.
    document.addEventListener(
      'variant:update',
      function (event) {
        var customEvent = /** @type {CustomEvent} */ (event);
        var html = customEvent.detail && customEvent.detail.data && customEvent.detail.data.html;

        // The section-rendered HTML (section-rendering-product-card) has DOPP
        // attrs on <product-card> with the new variant's data.
        var updatedDoppEl =
          html && typeof html.querySelector === 'function'
            ? html.querySelector(
                '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
              )
            : null;

        // Walk up from event.target to find the live card DOPP element.
        var eventTarget = event.target instanceof HTMLElement ? event.target : null;
        var liveDoppEl = eventTarget
          ? eventTarget.closest(
              '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
            )
          : null;

        if (!liveDoppEl && !updatedDoppEl) {
          return;
        }

        var productId = (updatedDoppEl || liveDoppEl).getAttribute('data-regios-dopp-product-id');
        if (!productId) return;

        // Sync new variant attrs onto all live DOPP elements for this product.
        // Skip sync when the section render returned no valid variant (e.g. out-of-stock
        // swatch with no available variant) — preserve existing attrs so DOPP can still
        // show a meaningful price rather than going blank.
        var newVariantId = updatedDoppEl && updatedDoppEl.getAttribute('data-regios-dopp-variant-id');
        if (updatedDoppEl && newVariantId && newVariantId !== '0') {
          var attrsToSync = [
            'data-regios-dopp-variant-id',
            'data-regios-dopp-regular-price-cents',
            'data-regios-dopp-compare-at-price-cents',
            'data-regios-dopp-collection-ids',
          ];
          var liveEls = document.querySelectorAll('[data-regios-dopp-product-id="' + productId + '"]');
          liveEls.forEach(function (liveEl) {
            attrsToSync.forEach(function (attr) {
              var val = updatedDoppEl.getAttribute(attr);
              if (val != null && val !== '') {
                liveEl.setAttribute(attr, val);
              } else {
                liveEl.removeAttribute(attr);
              }
            });
          });
        }

        // Defer DOPP re-run so product-price.js has time to update the DOM first.
        // liveDoppEl is the element WITH the DOPP attrs, so querySelectorAll on it
        // finds nothing (it only searches descendants). Scope to the parent instead.
        requestAnimationFrame(function () {
          var scopeRoot = liveDoppEl ? liveDoppEl.closest('product-card') || liveDoppEl.parentElement : null;
          ensureApiThenUpdate(scopeRoot || document);
        });
      },
      true,
    ); // capture phase — required because product-card.js calls stopPropagation()

    // Handle dynamically injected product grids (e.g. recommendations on PDP)
    // by watching for new elements that carry the Regios DOPP data attributes.
    // Also handles product-price.js replacing [ref="priceContainer"] after a
    // variant change — when the new container is inserted, find the nearest
    // DOPP ancestor and re-run DOPP for that card specifically.
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        var shouldUpdateDocument = false;
        /** @type {Element[]} */
        var scopedRootsToUpdate = [];

        mutations.forEach(function (mutation) {
          if (mutation.type !== 'childList') return;
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;

            // New DOPP element injected (e.g. product recommendations)
            if (
              node.matches &&
              node.matches(
                '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
              )
            ) {
              shouldUpdateDocument = true;
            } else if (
              node.querySelector &&
              node.querySelector(
                '[data-regios-dopp-product-id][data-regios-dopp-variant-id][data-regios-dopp-regular-price-cents]',
              )
            ) {
              shouldUpdateDocument = true;
            }

            // product-price.js just injected a fresh price container after a
            // variant change. Re-run DOPP scoped to the nearest product-card.
            if (node.matches && node.matches('.regios-dopp-generic-price-container')) {
              var doppAncestor = node.closest('product-card');
              if (doppAncestor) {
                scopedRootsToUpdate.push(doppAncestor);
              }
            }
          });

          // morph() (used by predictive search) patches the DOM in-place: it
          // removes DOPP-created elements (like .regios-dopp-description) that
          // aren't in the fresh server HTML instead of adding new nodes.
          // Detect this removal as the signal that DOPP output was wiped.
          mutation.removedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (
              node.hasAttribute('data-created-by-regios-dopp') ||
              (node.querySelector && node.querySelector('[data-created-by-regios-dopp]'))
            ) {
              shouldUpdateDocument = true;
            }
          });
        });

        if (shouldUpdateDocument) {
          ensureApiThenUpdate(document);
        }
        scopedRootsToUpdate.forEach(function (root) {
          ensureApiThenUpdate(root);
        });
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalRegiosDopp, { once: true });
  } else {
    initGlobalRegiosDopp();
  }
})();
